import React, { useEffect, useState } from 'react'
import { User } from '../../../models/User'
import styled from 'styled-components'
import { ResultJobsEvaluation } from '../../../models/ResultJobsEvaluation'
import { ResultJobsDto } from '../../../models/Dto/ResultJobsDto'
import { ActiveProps } from '../../Layout/CommonStyle'

interface Props {
  resultJobsDto: ResultJobsDto
  resultJobsDtos: ResultJobsDto[]
  setResultJobsDtos: React.Dispatch<React.SetStateAction<ResultJobsDto[]>>
  me: User
  setResultJobsDto: (resultJobsDto: ResultJobsDto) => void
  setIsPopup: (isPopup: boolean) => void
}

//const ResultJobsItem: React.FC<Props> = ({ resultJobsDto, me }) => {
function ResultJobsItem(props: Props) {
  const [evaluation, setEvaluation] = useState<ResultJobsEvaluation>(
    props.resultJobsDto.resultJobsEvaluation
  )

  useEffect(() => {
    const newEvaluation = {
      ...evaluation,
      total: evaluation.concreteness + evaluation.interest + evaluation.need,
    } as ResultJobsEvaluation

    const newResultJobsDto = {
      ...props.resultJobsDto,
      resultJobsEvaluation: newEvaluation,
    }

    props.setResultJobsDtos(
      props.resultJobsDtos.map((r) =>
        r.resultJobs.id === newResultJobsDto.resultJobs.id
          ? newResultJobsDto
          : r
      )
    )
  }, [evaluation])

  const handleConcreteness = (value: number) => {
    console.log('handleConcreteness', value)
    setEvaluation({
      ...evaluation,
      concreteness: value,
      total: evaluation.interest + evaluation.need + value,
    })
  }

  const handleInterest = (value: number) => {
    console.log('handleInterest', value)
    setEvaluation({
      ...evaluation,
      interest: value,
      total: evaluation.concreteness + evaluation.need + value,
    })
  }

  const handleNeed = (value: number) => {
    console.log('handleNeed', value)
    setEvaluation({
      ...evaluation,
      need: value,
      total: evaluation.concreteness + evaluation.interest + value,
    })
  }

  return (
    <Container>
      <img
        onClick={() => {
          props.setResultJobsDto(props.resultJobsDto)
          props.setIsPopup(true)
        }}
        src={process.env.PUBLIC_URL + props.resultJobsDto.resultJobs.posterUrl}
      />
      <Info>
        <h3>{props.resultJobsDto.resultJobs.jobName}</h3>
        <div>{props.resultJobsDto.resultJobs.jobContent}</div>
      </Info>
      <Evaluate>
        <EvaluateUnit>
          <div>구체성</div>
          <div>
            <PointButton
              onClick={() => handleConcreteness(1)}
              active={evaluation.concreteness === 1}
            >
              1
            </PointButton>
            <PointButton
              onClick={() => handleConcreteness(2)}
              active={evaluation.concreteness === 2}
            >
              2
            </PointButton>
            <PointButton
              onClick={() => handleConcreteness(3)}
              active={evaluation.concreteness === 3}
            >
              3
            </PointButton>
            <PointButton
              onClick={() => handleConcreteness(4)}
              active={evaluation.concreteness == 4}
            >
              4
            </PointButton>
            <PointButton
              onClick={() => handleConcreteness(5)}
              active={evaluation.concreteness === 5}
            >
              5
            </PointButton>
          </div>
        </EvaluateUnit>
        <EvaluateUnit>
          <div>흥미</div>
          <div>
            <PointButton
              onClick={() => handleInterest(1)}
              active={evaluation.interest === 1}
            >
              1
            </PointButton>
            <PointButton
              onClick={() => handleInterest(2)}
              active={evaluation.interest === 2}
            >
              2
            </PointButton>
            <PointButton
              onClick={() => handleInterest(3)}
              active={evaluation.interest === 3}
            >
              3
            </PointButton>
            <PointButton
              onClick={() => handleInterest(4)}
              active={evaluation.interest === 4}
            >
              4
            </PointButton>
            <PointButton
              onClick={() => handleInterest(5)}
              active={evaluation.interest === 5}
            >
              5
            </PointButton>
          </div>
        </EvaluateUnit>
        <EvaluateUnit>
          <div>사회적 필요성</div>
          <div>
            <PointButton
              onClick={() => handleNeed(1)}
              active={evaluation.need === 1}
            >
              1
            </PointButton>
            <PointButton
              onClick={() => handleNeed(2)}
              active={evaluation.need === 2}
            >
              2
            </PointButton>
            <PointButton
              onClick={() => handleNeed(3)}
              active={evaluation.need === 3}
            >
              3
            </PointButton>
            <PointButton
              onClick={() => handleNeed(4)}
              active={evaluation.need === 4}
            >
              4
            </PointButton>
            <PointButton
              onClick={() => handleNeed(5)}
              active={evaluation.need === 5}
            >
              5
            </PointButton>
          </div>
        </EvaluateUnit>
        <EvaluateUnit>
          <div>총점 : {evaluation.total} 점</div>
        </EvaluateUnit>
      </Evaluate>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border: 1px solid #aaa;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    border: none;
    border-bottom: 1px solid #aaa;
  }

  img {
    width: 250px !important;
    min-width: 250px;

    @media (max-width: 768px) {
      width: 95%;
      min-width: 95%;
      box-sizing: border-box;
    }
  }
`

const Info = styled.div`
  width: 100%;
  padding: 20px;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  h3 {
    padding-bottom: 10px;
    font-size: 1.2rem;
  }
  div {
    white-space: pre;
  }

  @media (max-width: 768px) {
    padding: 30px 10px;
    box-sizing: border-box;
    border: none;
  }
`

const Evaluate = styled.div`
  width: 350px;
  padding: 20px 10px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }
`

const EvaluateUnit = styled.div`
  padding-bottom: 10px;
  @media (max-width: 768px) {
    text-align: center;

    & > div {
      padding-bottom: 10px;
    }
  }
`

// const PointButton = styled.button<{ selected?: boolean }>`
const PointButton = styled.button`
  margin-right: 3px;
  padding: 3px 8px;
  background-color: ${(props: ActiveProps) =>
    props.active ? 'tomato' : 'white'};
  color: ${(props: ActiveProps) => (props.active ? 'white' : 'black')};

  @media (max-width: 768px) {
    padding: 8px 12px;
  }
`

export default ResultJobsItem
